export const USER_INFO='USER_INFO';
export const TOKEN='TOKEN';
export const DB_TOKEN='DB_TOKEN';
export const PATIENTS_LIST_VIEW_TYPE='PATIENTS_LIST_VIEW_TYPE';
export const NEARBY_CITIES='NEARBY_CITIES';
export const INDEXED_DB_NAME='careipro_clinic_management';
export const OBJECT_STORES = {
    store_meta_data:'store_meta_data',
    stores:'data_stores',
    active_doctors: "active_doctors",
    in_active_doctors: "in_active_doctors",
    un_approve_doctors: "un_approve_doctors",
    doctor_settings: "doctor_settings",
    todays_patients:"todays_patients",
    todays_bookings:"todays_bookings",
}